import { render } from "./PatientsDatatableFormAddress.vue?vue&type=template&id=67fa01d2&scoped=true"
import script from "./PatientsDatatableFormAddress.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableFormAddress.vue?vue&type=script&lang=js"

import "./PatientsDatatableFormAddress.vue?vue&type=style&index=0&id=67fa01d2&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67fa01d2"]])

export default __exports__